import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { LoginService } from '../services/login.service';

interface LoginData {
  email: string;
  password: string;
}

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, HeaderComponent, FooterComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  loginData: LoginData = {
    email: '',
    password: ''
  };

  showPassword: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';

  constructor(
    private router: Router,
    private loginService: LoginService,
    private meta: Meta,
    private title: Title
  ) {}

  /**
   * Bascule la visibilité du mot de passe
   */
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  /**
   * Gère la soumission du formulaire de connexion
   */
  async onSubmit(): Promise<void> {
    if (this.isLoading) return;

    // Reset messages
    this.errorMessage = '';
    this.successMessage = '';

    // Validation basique
    if (!this.loginData.email || !this.loginData.password) {
      this.errorMessage = 'Veuillez saisir votre email et mot de passe';
      return;
    }

    this.isLoading = true;

    try {
      const result = await this.loginService.loginUser(
        this.loginData.email, 
        this.loginData.password
      );

      if (result.success) {
        this.successMessage = result.message;
        console.log('Connexion réussie:', result.data);
        
        // Rediriger vers l'espace client après un court délai
        setTimeout(() => {
          this.router.navigate(['/espace-client']);
        }, 1000);
      } else {
        this.errorMessage = result.message;
        console.error('Erreur de connexion:', result.message);
      }
    } catch (error: any) {
      this.errorMessage = 'Une erreur est survenue. Veuillez réessayer.';
      console.error('Erreur lors de la connexion:', error);
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * Gère le clic sur "Mot de passe oublié"
   */
  onForgotPassword(): void {
    console.log('Mot de passe oublié pour:', this.loginData.email);
    // Ici vous pourriez rediriger vers une page de réinitialisation de mot de passe
    // ou ouvrir un modal
  }

  /**
   * Gère le clic sur "Créer un compte"
   */
  onCreateAccount(): void {
    console.log('Redirection vers la page d\'inscription');
    // Ici vous pourriez rediriger vers une page d'inscription
    // this.router.navigate(['/register']);
  }

  /**
   * Initialise le composant
   */
  ngOnInit(): void {
    // Définir le titre de la page (48 caractères - optimal)
    this.title.setTitle('Connexion – Espace client pdf-to-word.fr');
    
    // Définir les meta tags SEO (160 caractères - optimal)
    this.meta.updateTag({ name: 'description', content: 'Connectez-vous à votre espace client pdf-to-word.fr pour accéder à vos fichiers convertis, gérer vos abonnements et convertir de nouveaux PDF en Word.' });
    this.meta.updateTag({ name: 'keywords', content: 'connexion pdf-to-word, espace client PDF Word, compte utilisateur, login conversion PDF, se connecter pdf-to-word.fr' });
    
    // Meta tags supplémentaires pour le SEO
    this.meta.updateTag({ property: 'og:title', content: 'Connexion – Espace client pdf-to-word.fr' });
    this.meta.updateTag({ property: 'og:description', content: 'Connectez-vous à votre espace client pdf-to-word.fr pour accéder à vos fichiers convertis, gérer vos abonnements et convertir de nouveaux PDF en Word.' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
  }
}
